import React, { useEffect, useState } from "react";
import { Box, CircularProgress, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";

import { addAuditorValidation } from "./schema";
import { APIEndpoints } from "../../../redux/constants";
import ErrorIcon from "@mui/icons-material/Error";
import CeroSideSheetDrawer from "../../../components/CeroSideSheetDrawer";
import useStyles from "./styles";
import axios from "axios";
import { getCookie } from "../../../services/cookie";
import { getAuditorList } from "../../../redux/actions/audit";

const AddAudiorDrawer = (props) => {
  const { onClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const auditSummaryData = useSelector((state) => state.audit.auditorList.data);

  useEffect(() => {
    dispatch(getAuditorList());
  }, [dispatch]);

  const [isLoading, setIsLoading] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isEmailAvailable, setIsEmailAvailable] = useState(true);
  const formik = useFormik({
    initialValues: {
      email: auditSummaryData.email || "",
    },
    validationSchema: addAuditorValidation,
    enableReinitialize: true,
    onSubmit: () => {},
  });

  const checkEmailAvailability = async (email, save) => {
    try {
      const response = await axios.post(APIEndpoints.EMAIL_VALIDATE(), {
        email: email,
        save: false,
      });
      if (response.data.isAvailable) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  const authToken = getCookie("auth_token_admin");
  const handleEmailChange = async (event) => {
    const email = event.target.value;
    formik.handleChange(event);
    try {
      await addAuditorValidation.validate({ email });
      setIsEmailValid(true);
    } catch (error) {
      setIsEmailValid(false);
      return;
    }
    try {
      setIsLoading(true);
      const response = await axios.post(
        APIEndpoints.EMAIL_VALIDATE(),
        {
          email: email,
          save: false,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setIsLoading(false);
      setIsEmailAvailable(!response.data.isAvailable);
    } catch (error) {
      setIsLoading(false);
      setIsEmailAvailable(false);
      enqueueSnackbar(error.response.data.detail, { variant: "error" });
    }
  };

  const onSubmitAuditorData = async () => {
    const isValidEmail = await formik.validateForm();
    if (isValidEmail) {
      const email = formik.values.email;
      const isEmailAvailable = await checkEmailAvailability(email, true);
      const response = await axios.post(
        APIEndpoints.EMAIL_VALIDATE(),
        {
          email: email,
          save: true,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      dispatch(getAuditorList());
      enqueueSnackbar("Auditor added successfully", { variant: "success" });
      formik.resetForm();
      onClose();
    }
  };

  const getPrimaryPaymentDrawer = () => {
    const isInvalidEmail =
      formik.touched.email || !isEmailValid || !isEmailAvailable;
    return (
      <Box className={classes.mainContainer}>
        <TextField
          required
          id="email"
          name="email"
          label="Email"
          fullWidth
          value={formik.values.email}
          onChange={handleEmailChange}
          error={isInvalidEmail}
          helperText={
            isInvalidEmail ? (
              <>
                <ErrorIcon color="red" fontSize="small" />
                Invalid email address
              </>
            ) : (
              ""
            )
          }
          InputProps={{
            endAdornment: (
              <div style={{ position: "relative" }}>
                {isLoading && (
                  <CircularProgress
                    size={20}
                    style={{ transform: "translateY(-50%)", color: "#8C2148" }}
                  />
                )}
              </div>
            ),
          }}
        />
      </Box>
    );
  };

  return (
    <CeroSideSheetDrawer
      primaryDrawer={{
        drawerOpen: props.isOpen,
        onClose: () => props.onClose(false),
        content: getPrimaryPaymentDrawer(),
        header: { title: "Add Auditor" },
        footer: {
          primaryBtnTitle: "Save",
          secondaryBtnTitle: "Cancel",
          primaryBtnAction: onSubmitAuditorData,
          secondaryBtnAction: () => props.onClose(false),
          disablePrimaryBtn:
            !formik.dirty ||
            !formik.isValid ||
            !isEmailAvailable ||
            !isEmailValid,
        },
        classes: {
          drawerContainer: classes.drawerContainer,
          contentArea: classes.drawerContentArea,
        },
      }}
    />
  );
};

export default AddAudiorDrawer;
